import { callProcedure, transformToProcedurePayload } from 'clickNgo/helpers/api'

export type ConfirmKeyInitiativesReviewParams = {
  partnerId: string
  fYear: number
  programType?: string
}

export const buildConfirmKeyInitiativesReviewData = ({
  partnerId,
  fYear,
  programType,
}: ConfirmKeyInitiativesReviewParams) => {
  const normalizedProgramType = programType?.trim()

  return {
    ...transformToProcedurePayload({
      partnerId,
      fYear,
      ...(normalizedProgramType ? { programType: normalizedProgramType } : {}),
    }),
    'p.Action': 'KI Review',
  }
}

export const confirmKeyInitiativesReview = async (
  params: ConfirmKeyInitiativesReviewParams
): Promise<void> => {
  const response = await callProcedure({
    url: '/webservice/621/sp/v3/spJBPPlanReview/call',
    method: 'POST',
    data: buildConfirmKeyInitiativesReviewData(params),
  })

  if ('error' in response) {
    throw response.error
  }
}
